import React from 'react';
import {Body, Icon, IconName} from '@lightricks/react-design-system';
import {YOUTUBE_DS_ICON_OVERRIDES} from '@/config/constants';
import {DELIVERABLE_ICON_NAME} from '@/config/deliverableKinds';
import type {CampaignBriefDeliverableItem} from '@/types/campaign';
import styles from './DeliverableCard.module.scss';

const DELIVERABLE_TYPE_LABEL: Record<string, string> = {
  story_post: 'Instagram Story',
  feed_post_photo: 'Instagram Feed Post',
  reel_post: 'Instagram Reel',
  tiktok_video: 'TikTok Post',
  content_standard_photo: 'Photo',
  content_standard_video: 'Video',
  content_premium_photo: 'Premium photo',
  content_premium_video: 'Premium video',
  youtube_short_form_video: 'Short video',
  youtube_long_form_video: 'Long video',
  youtube_short: 'YouTube Short',
};

interface DeliverableCardProps {
  deliverable: CampaignBriefDeliverableItem;
  testID?: string;
}

function DeliverableCard({
  deliverable,
  testID = 'deliverable-card',
}: DeliverableCardProps) {
  const iconName = DELIVERABLE_ICON_NAME[deliverable.itemType] as
    | IconName
    | undefined;
  const isYoutube = deliverable.itemType.includes('youtube');
  const typeLabel =
    DELIVERABLE_TYPE_LABEL[deliverable.itemType] ??
    deliverable.itemType.replace(/_/g, ' ');

  return (
    <div data-testid={testID} className={styles.card}>
      <div className={styles.header}>
        {iconName ? (
          <Icon
            size="medium"
            appearance="neutral"
            name={iconName}
            {...(isYoutube ? YOUTUBE_DS_ICON_OVERRIDES : {})}
          />
        ) : null}
        <Body size="md" className={styles.typeLabel}>
          {typeLabel}
        </Body>
      </div>
      {deliverable.description ? (
        <>
          <hr className={styles.divider} />
          <div className={styles.description}>
            <Body size="md">{deliverable.description}</Body>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default DeliverableCard;
